export default __webpack_public_path__ + "static/media/header-2.569e765c.jpg";